const common = [
    {
        path: '/common/problem',
        name: 'commonProblem',
        component: () => import('@/view/common/problem'),
    },

]
export default common